<template>
    <div id="app">
        <div v-if="isShowMain">
            <!-- route -->
            <router-view :key="$route.fullPath"></router-view>
            <!-- // route -->
        </div>
    </div>
</template>

<script>
    export default {
        components: {},

        data() {
            return {
            
                isShowMain : false
            };
        },

        methods: {

            // 진입점
            init() {

                // 1분 간격(JWT & AES256)
                setInterval(async () => {
                    this.getData();
                }, 1000 * 60);

                this.getData();
            }
            
            // 데이터 조회
            , getData() {

                var data = {};
                data["gubunProc"] = "SYSTEM_RESET_KEY";
                
                // API 조회
                this.$SendPost("/vue_api/common/common/init", data, this.getDataReturn);

            }

            // 데이터 리턴
            , getDataReturn(data, err) {

                if (data) {

                    // 데이터 처리
                    if (data.RESULT_YN === "Y") {

                        this.isShowMain = true;
                    }
                }
            }
        },

        beforeCreate() {
        },

        created() {
        },

        beforeMount() {
        },

        mounted() {
            this.init();
        },

        beforeUpdate() {
        },

        updated() {
        },

        beforeDestroy() {
        },

        destroyed() {
        },
    };
</script>
